unit View.Ncm.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UHelperServer, System.StrUtils, UConstantes, WEBLib.WebCtrls,
  WEBLib.XLSX, XData.Web.Client, UUtils, UWeb.Enum, UPersonalizacao_Tabela,
  UPersonalizacao_Tabela.Interfaces;

type
  TFViewNcmList = class(TForm)
    btNew: TButton;
    NcmDataset: TXDataWebDataSet;
    NcmDatasetid: TIntegerField;
    NcmDatasetncm: TStringField;
    NcmDatasetdescricao: TStringField;
    NcmDatasetdata_inicio_vigencia: TDateTimeField;
    NcmDatasetdata_fim_vigencia: TDateTimeField;
    NcmDatasetexcluido: TBooleanField;
    NcmDatasetinclusao: TDateTimeField;
    NcmDatasetalteracao: TDateTimeField;
    NcmDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    tmrConsulta: TTimer;
    cbbTipoImportacao: TComboBox;
    btnImportarNcm: TButton;
    btnUploadNcm: TButton;
    lblErroNcm: TLabel;
    wfpNcm: TFilePicker;
    XDataClientImportNcm: TXDataWebClient;
    XDataWebClientImportIbptax: TXDataWebClient;
    excelImport: TXLSX;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure WebDBTableControl1GetCellClass(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure WebDBTableControl1GetCellData(Sender: TObject; ACol,
      ARow: Integer; AField: TField; var AValue: string);
    procedure tmrConsultaTimer(Sender: TObject);
    procedure edSearchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure btnImportarNcmClick(Sender: TObject);
    procedure cbbTipoImportacaoChange(Sender: TObject);
    [Async]
    procedure btnUploadNcmClick(Sender: TObject); async;
    procedure wfpNcmGetFileAsArrayBuffer(Sender: TObject; AFileIndex: Integer;
      ABuffer: TJSArrayBufferRecord);
    procedure excelImportSheetLoaded(Sender: TObject; ASheetName: string);
    procedure XDataClientImportNcmError(Error: TXDataClientError);
    procedure XDataClientImportNcmLoad(Response: TXDataClientResponse);
    procedure wfpNcmGetFileAsText(Sender: TObject; AFileIndex: Integer;
      AText: string);
    procedure XDataWebClientImportIbptaxError(Error: TXDataClientError);
    procedure XDataWebClientImportIbptaxLoad(Response: TXDataClientResponse);
    procedure cbbTipoImportacaoClick(Sender: TObject);
    procedure wfpNcmChange(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
  private
    const
      cCabecalhoPlanilhaSefaz = 'NCM;INÍCIO DE VIGÊNCIA DA NCM  NO SISCOMEX;FIM DE VIGÊNCIA DA NCM NO SISCOMEX;UTRIB PARA USO EM OPERAÇÕES DE EXPORTAÇÃO (ABREVIATURA);DESCRIÇÃO DA UTRIB UTILIZADA EM OPERAÇÕES DE EXPORTAÇÃO;';
      cCabecalhoPlanilhaIbptax = 'CODIGO;EX;TIPO;DESCRICAO;NACIONALFEDERAL;IMPORTADOSFEDERAL;ESTADUAL;MUNICIPAL;VIGENCIAINICIO;VIGENCIAFIM;CHAVE;VERSAO;FONTE';
    var
      FEditProc: TEditProc;
      FGridPlugin: TGridPlugin;
      FArquivoProcessado : Integer;
      FPersonalizacaoTabela: IPersonalizacao_Tabela;

    function ValidarDados : string;
    procedure ImportarNcmIbptax(pTextoArquivo : string);
    procedure ImportarNcmSefaz;
    procedure ImportarTabelaIbptax(pTextoArquivo : string);
    procedure SetValueOrNullJson(pCampo, pValor : string; var pJson : TJSObject);
    function GetNcmFormatado(pNcm : string) : string;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewNcmList: TFViewNcmList;

implementation

uses
  ConnectionModule,
  View.Main;

{$R *.dfm}

{ TFViewNcmList }

procedure TFViewNcmList.btnImportarNcmClick(Sender: TObject);
begin
  wfpNcm.Files.Clear;
  lblErroNcm.Visible := False;
  cbbTipoImportacao.ItemIndex := 0;
  wfpNcm.Enabled := False;
  FArquivoProcessado := 0;
end;

procedure TFViewNcmList.btnUploadNcmClick(Sender: TObject);
var
  lErro : string;
  lIndice: Integer;
begin
  lblErroNcm.Visible := False;
  lErro := ValidarDados;

  if lErro <> '' then
  begin
    lblErroNcm.Caption := lErro;
    lblErroNcm.Visible := True;
    Exit;
  end;

  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, 'Tem certeza que deseja realizar essa importação?')) then
  begin
    FArquivoProcessado := 0;

    TUtils.ChamarDivLoading;

    case cbbTipoImportacao.ItemIndex of
      1: wfpNcm.Files.Items[0].GetFileAsArrayBuffer;
      2, 3: wfpNcm.Files.Items[0].GetFileAsText;
    end;
  end;
end;

procedure TFViewNcmList.cbbTipoImportacaoChange(Sender: TObject);
begin
  wfpNcm.Enabled := cbbTipoImportacao.ItemIndex <> 0;
   wfpNcm.Files.Clear;

  if cbbTipoImportacao.ItemIndex <> 0 then
  begin
    wfpNcm.Multifile := cbbTipoImportacao.ItemIndex = 3;

    if cbbTipoImportacao.ItemIndex = 1 then
      wfpNcm.Accept:= '.xlsx'
    else
      wfpNcm.Accept := '.csv';
  end;
end;

procedure TFViewNcmList.cbbTipoImportacaoClick(Sender: TObject);
begin
  lblErroNcm.Visible := False;
end;

procedure TFViewNcmList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewNcmList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewNcmList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewNcmList, AElementID, Result, @AfterCreate);
end;

procedure TFViewNcmList.edSearchKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if Key = 13 then
  begin
    FGridPlugin.SetFilterText(edSearch.Text, True);
  end;
end;

procedure TFViewNcmList.edSearchKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Interval := FTimerConsulta;
  tmrConsulta.Enabled := True;
end;

procedure TFViewNcmList.excelImportSheetLoaded(Sender: TObject;
  ASheetName: string);
begin
  ImportarNcmSefaz;
end;

function TFViewNcmList.GetNcmFormatado(pNcm: string): string;
const
  cTamanhoMaximo = 8;
var
  lTamanho: Integer;
begin
  lTamanho := Length(pNcm);

  if lTamanho < cTamanhoMaximo then
  begin
    while lTamanho < cTamanhoMaximo do
    begin
      Result := Result + '0';
      Inc(lTamanho);
    end;

    Result := Result + pNcm;
  end
  else
    Result := pNcm;
end;

procedure TFViewNcmList.ImportarNcmSefaz;
var
  lIndice : Integer;
  lNcm,
  lInicioVigencia,
  lFimVigencia,
  lCabecalhoPadrao : string;
  lExcluido : Integer;
  JSDate: TJSDate;
  lArrayTabelaNcm: TJSArray;
  lJsObject: TJSObject;
begin
  for lIndice := 1 to excelImport.ColumnCount - 1 do
  begin
    lCabecalhoPadrao := lCabecalhoPadrao + UpperCase(excelImport.CellAsString[lIndice, 1]) + ';';
  end;

  if Trim(lCabecalhoPadrao) <> cCabecalhoPlanilhaSefaz then
  begin
    TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, 'Planilha inválida!');
    Exit;
  end;

  lArrayTabelaNcm := TJSArray.new;

  for lIndice := 2 to excelImport.RowCount do
  begin
    lExcluido := 0;
    lNcm := GetNcmFormatado(excelImport.CellAsString[1, lIndice]);
    lInicioVigencia := excelImport.CellAsString[2, lIndice];
    lFimVigencia := excelImport.CellAsString[3, lIndice];

    lJsObject := TJSObject.New;
    lJsObject.Properties['ncm'] := lNcm;
    lJsObject.Properties['descricao'] := UpperCase('Importação Sefaz');

    if Trim(lInicioVigencia) = '' then
      lJsObject.Properties['data_inicio_vigencia'] := null
    else
    begin
      jsDate := TJSDate.New(lInicioVigencia);
      lInicioVigencia := FormatDateTime('yyyy-mm-dd', EncodeDate(jsDate.UTCFullYear, jsDate.UTCMonth + 1, jsDate.UTCDate));
      lJsObject.Properties['data_inicio_vigencia'] := lInicioVigencia;
    end;

    if Trim(lFimVigencia) = '' then
      lJsObject.Properties['data_fim_vigencia'] := null
    else
    begin
      jsDate := TJSDate.New(lFimVigencia);
      lFimVigencia := FormatDateTime('dd/mm/yyyy', EncodeDate(jsDate.UTCFullYear, jsDate.UTCMonth + 1, jsDate.UTCDate));

      if StrToDate(lFimVigencia) <= Date then
        lExcluido := 1;

      lJsObject.Properties['data_fim_vigencia'] := FormatDateTime('yyyy-mm-dd', StrToDate(lFimVigencia));
    end;

    lJsObject.Properties['excluido'] := lExcluido;
    lArrayTabelaNcm.push(lJsObject);
  end;

  XDataClientImportNcm.RawInvoke('ISinc_Servidor_Retaguarda_Service.ImportarNcm',
    ['SEFAZ', wfpNcm.Files[0].Name, lArrayTabelaNcm]);
end;

procedure TFViewNcmList.ImportarTabelaIbptax(pTextoArquivo: string);
var
  lLinhas,
  lFields: TArray<string>;
  lIndice: Integer;
  lArrayIbptax: TJSArray;
  lJsObject: TJSObject;
  lUfSigla,
  lVigenciaInicio,
  lVigenciaFim,
  lCabecalhoPadrao,
  lNcm,
  lBackupNcm,
  lTipo: string;
begin
  TUtils.SetMensagemDivLoading(FArquivoProcessado.ToString + ' tabela(s) importada(s) de ' +
    wfpNcm.Files.Count.ToString);

  lLinhas := pTextoArquivo.Split([sLineBreak]);
  lCabecalhoPadrao := UpperCase(lLinhas[0]);

  if Trim(lCabecalhoPadrao) <> cCabecalhoPlanilhaIbptax then
  begin
    TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, 'Planilha ' +
      wfpNcm.Files[FArquivoProcessado].Name+' inválida!');
    Exit;
  end;

  lArrayIbptax := TJSArray.new;

  lUfSigla := UpperCase(wfpNcm.Files[FArquivoProcessado].Name);
  lUfSigla := Copy(lUfSigla, Length('TABELAIBPTAX') + 1, 2);
  lBackupNcm := '';

  for lIndice := 1 to High(lLinhas) do
  begin
    if lLinhas[lIndice].Trim <> '' then
    begin
      lFields := lLinhas[lIndice].Split([';']);

      lTipo := lFields[2];

      if lTipo = '0' then
        lNcm := GetNcmFormatado(lFields[0])
      else
        lNcm := lFields[0];

      if lNcm = lBackupNcm then
        Continue
      else
        lBackupNcm := lNcm;

      lVigenciaInicio := lFields[8];
      lVigenciaFim := lFields[9];

      lJsObject := TJSObject.New;
      lJsObject.Properties['ncm'] := lNcm;
      lJsObject.Properties['tipo'] := lFields[2];
      lJsObject.Properties['aliquota_federal'] := lFields[4];
      lJsObject.Properties['aliquota_importacao_federal'] := lFields[5];
      lJsObject.Properties['aliquota_estadual'] := lFields[6];
      lJsObject.Properties['aliquota_municipal'] := lFields[7];
      SetValueOrNullJson('chave', UpperCase(lFields[10]), lJsObject);
      SetValueOrNullJson('versao', UpperCase(lFields[11]), lJsObject);
      SetValueOrNullJson('fonte', UpperCase(lFields[12]), lJsObject);

      if Trim(lVigenciaInicio) = '' then
        lJsObject.Properties['data_vigencia_inicio'] := null
      else
      begin
        lJsObject.Properties['data_vigencia_inicio'] := FormatDateTime('yyyy-mm-dd',
          StrToDate(lVigenciaInicio));
      end;

      if Trim(lVigenciaFim) = '' then
        lJsObject.Properties['data_vigencia_fim'] := null
      else
      begin
        lJsObject.Properties['data_vigencia_fim'] := FormatDateTime('yyyy-mm-dd',
          StrToDate(lVigenciaFim));
      end;

      lArrayIbptax.push(lJsObject);
    end;
  end;

  XDataWebClientImportIbptax.RawInvoke('ISinc_Servidor_Retaguarda_Service.ImportarIbptax', [lUfSigla, lArrayIbptax]);
end;

procedure TFViewNcmList.SetValueOrNullJson(pCampo, pValor: string;
  var pJson: TJSObject);
begin
  if Trim(pValor) = '' then
    pJson.Properties[pCampo] := null
  else
    pJson.Properties[pCampo] := pValor;
end;

procedure TFViewNcmList.ImportarNcmIbptax(pTextoArquivo: string);
var
  lLinhas,
  lFields: TArray<string>;
  lIndice: Integer;
  lArrayNcm: TJSArray;
  lJsObject: TJSObject;
  lNcm,
  lDescricao,
  lCabecalhoPadrao,
  lBackupNcm,
  lTipo : string;
begin
  lLinhas := pTextoArquivo.Split([sLineBreak]);

  lCabecalhoPadrao := UpperCase(lLinhas[0]);

  if Trim(lCabecalhoPadrao) <> cCabecalhoPlanilhaIbptax then
  begin
    TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, 'Planilha inválida!');
    Exit;
  end;

  lArrayNcm := TJSArray.new;

  lBackupNcm := '';

  for lIndice := 1 to High(lLinhas) do
  begin
    if lLinhas[lIndice].Trim <> '' then
    begin
      lFields := lLinhas[lIndice].Split([';']);

      lTipo := lFields[2];

      if lTipo = '0' then
        lNcm := GetNcmFormatado(lFields[0])
      else
        lNcm := lFields[0];

      if lNcm = lBackupNcm then
        Continue
      else
        lBackupNcm := lNcm;

      lDescricao := lFields[3];

      lJsObject := TJSObject.New;
      lJsObject.Properties['ncm'] := lNcm;
      lJsObject.Properties['tipo'] := lTipo;
      lJsObject.Properties['descricao'] := UpperCase(lDescricao.Replace('"', ''));

      lArrayNcm.push(lJsObject);
    end;
  end;

  XDataClientImportNcm.RawInvoke('ISinc_Servidor_Retaguarda_Service.ImportarNcm',
    ['IBPTAX', wfpNcm.Files[0].Name, lArrayNcm]);
end;

procedure TFViewNcmList.tmrConsultaTimer(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);

  tmrConsulta.Enabled := False;
  tmrConsulta.Interval := FTimerConsulta;
end;

function TFViewNcmList.ValidarDados: string;
var
  lIndice : Integer;
begin
  Result := EmptyStr;

  if Trim(cbbTipoImportacao.Text) = '' then
    Result := 'Selecione o tipo de importação!'
  else if wfpNcm.Files.Count <= 0 then
    Result := 'Selecione o(s) arquivo(s)!'
  else if (cbbTipoImportacao.ItemIndex = 3) and (NcmDataset.RecordCount <= 0) then
    Result := 'Faça a importação dos NCMs antes de importar as tabelas do IBPTAX!'
  else
  begin
    case cbbTipoImportacao.ItemIndex of
      1:
      begin
        if not wfpNcm.Files[0].Name.ToLower.EndsWith('.xlsx') then
          Result := 'Extensão inválida! Importe o arquivo com formato .xlsx';
      end;
      2:
      begin
        if not wfpNcm.Files[0].Name.ToLower.EndsWith('.csv') then
          Result := 'Extensão inválida! Importe o arquivo com formato .csv';
      end;
      3:
      begin
        for lIndice := 0 to wfpNcm.Files.Count - 1 do
        begin
          if not wfpNcm.Files[lIndice].Name.ToLower.EndsWith('.csv') then
          begin
            Result := 'Existe(m) arquivos(s) com formato inválido! Importe arquivos com formato .csv';
            Break;
          end;
        end;
      end;
    end;
  end;
end;

procedure TFViewNcmList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewNcmList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Ação' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      NcmDataset.Connection.Model.DefaultSchema.FindEntityType(NcmDataset.EntitySetName),
      NcmDataset.CurrentData
    );

    Button := TButton.Create(nil);

    if TUtils.IsPerfilFacilSistemas(TUtils.FUsuario) then
      Button.Caption := '<i class="fa fa-edit"></i>'
    else
      Button.Caption := '<i class="fa fa-eye"></i>';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.setAttribute('data-test', 'btn_visualizar_ncm');
  end;
end;

procedure TFViewNcmList.WebDBTableControl1GetCellClass(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['descricao']) of
      0: AClassName := 'text-left';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewNcmList.WebDBTableControl1GetCellData(Sender: TObject; ACol,
  ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow > 0 then
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['excluido', 'descricao']) of
      0:
      begin
        if AValue = 'True' then
          AValue := '<i class="fas fa-check text-success"><i>'
        else if AValue = 'False' then
          AValue := '<i class="fas fa-times text-danger"><i>'
      end;
      1:
      begin
        if Length(AValue) > 100 then
          AValue := Copy(AValue, 1, 100) + '...';
      end;
    end;
  end;
end;

procedure TFViewNcmList.WebFormCreate(Sender: TObject);
begin
  FPersonalizacaoTabela := TPersonalizacao_Tabela.Create(Self.Name, WebDBTableControl1,
    cbPageSize);

  TUtils.SetValorDicionarioClasses('ncm', 'active');
  TUtils.SetValorDicionarioClasses('tributacoes_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_tributacoes', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    NcmDataset,
    lcPaginator,
    lbPaginationInfo
  );

  FGridPlugin.FDatasetPlugin.FOrderByPadrao := 'alteracao desc';
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewNcmList.WebFormShow(Sender: TObject);
begin
  if not TUtils.PossuiPermissao(NcmDataset.EntitySetName.ToLower, TTipoPermissao.INSERIR) then
  begin
    btNew.Enabled := False;
    TUtils.ControlarSelect('cbbTipoImportacao', '1 - Ncm tabela SEFAZ', True);
    TUtils.ControlarSelect('cbbTipoImportacao', '2 - Ncm tabela IBPTAX (Individual - Atualização da descrição)', True);
  end;

  if not TUtils.PossuiPermissao('ncm_ibptax', TTipoPermissao.INSERIR) then
    TUtils.ControlarSelect('cbbTipoImportacao', '3 - Tabelas IBPTAX (Todos os estados - Atualização das alíquotas)', True);
end;

procedure TFViewNcmList.wfpNcmChange(Sender: TObject);
begin
  lblErroNcm.Visible := False;
end;

procedure TFViewNcmList.wfpNcmGetFileAsArrayBuffer(Sender: TObject;
  AFileIndex: Integer; ABuffer: TJSArrayBufferRecord);
begin
  excelImport.Load(ABuffer);
end;

procedure TFViewNcmList.wfpNcmGetFileAsText(Sender: TObject;
  AFileIndex: Integer; AText: string);
begin
  if cbbTipoImportacao.ItemIndex = 2 then
    ImportarNcmIbptax(AText)
  else
    ImportarTabelaIbptax(AText);
end;

procedure TFViewNcmList.XDataClientImportNcmError(Error: TXDataClientError);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, Error.ErrorMessage);
end;

procedure TFViewNcmList.XDataClientImportNcmLoad(
  Response: TXDataClientResponse);
begin
  asm
    $('#modal_importar_ncm').modal('hide');
  end;

  TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, 'Dados importados com sucesso!');
  FGridPlugin.Load;
end;

procedure TFViewNcmList.XDataWebClientImportIbptaxError(
  Error: TXDataClientError);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, Error.ErrorMessage);
end;

procedure TFViewNcmList.XDataWebClientImportIbptaxLoad(
  Response: TXDataClientResponse);
var
  lLog : string;
  lIndice: Integer;
begin
  Inc(FArquivoProcessado);

  if FArquivoProcessado > wfpNcm.Files.Count - 1 then
  begin
    asm
      $('#modal_importar_ncm').modal('hide');
    end;

    for lIndice := 0 to wfpNcm.Files.Count - 1 do
    begin
      lLog := lLog + wfpNcm.Files[lIndice].Name + ', ';
    end;

    lLog := Copy(lLog, 1, Length(lLog) - 2);

    TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, 'Dados importados com sucesso!');

    FViewMain.GerarLog(0, 'ncm_ibptax', 'Importação de planilhas', '{"planilhas_importadas":"' +
      lLog + '"}');
  end
  else
    wfpNcm.Files.Items[FArquivoProcessado].GetFileAsText;
end;

procedure TFViewNcmList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.ncm.list.pagination.info');
  lblErroNcm := TLabel.Create('lblErroNcm');
  btNew := TButton.Create('view.ncm.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.ncm.list.table');
  cbPageSize := TComboBox.Create('view.ncm.list.cbPageSize');
  edSearch := TEdit.Create('view.ncm.list.search');
  lcPaginator := TListControl.Create('view.ncm.list.pagination');
  cbbTipoImportacao := TComboBox.Create('cbbTipoImportacao');
  btnImportarNcm := TButton.Create('btnImportarNcm');
  btnUploadNcm := TButton.Create('btnUploadNcm');
  wfpNcm := TFilePicker.Create('wfpNcm');
  NcmDataset := TXDataWebDataSet.Create(Self);
  NcmDatasetid := TIntegerField.Create(Self);
  NcmDatasetncm := TStringField.Create(Self);
  NcmDatasetdescricao := TStringField.Create(Self);
  NcmDatasetdata_inicio_vigencia := TDateTimeField.Create(Self);
  NcmDatasetdata_fim_vigencia := TDateTimeField.Create(Self);
  NcmDatasetexcluido := TBooleanField.Create(Self);
  NcmDatasetinclusao := TDateTimeField.Create(Self);
  NcmDatasetalteracao := TDateTimeField.Create(Self);
  NcmDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  tmrConsulta := TTimer.Create(Self);
  XDataClientImportNcm := TXDataWebClient.Create(Self);
  XDataWebClientImportIbptax := TXDataWebClient.Create(Self);
  excelImport := TXLSX.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  lblErroNcm.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  cbbTipoImportacao.BeforeLoadDFMValues;
  btnImportarNcm.BeforeLoadDFMValues;
  btnUploadNcm.BeforeLoadDFMValues;
  wfpNcm.BeforeLoadDFMValues;
  NcmDataset.BeforeLoadDFMValues;
  NcmDatasetid.BeforeLoadDFMValues;
  NcmDatasetncm.BeforeLoadDFMValues;
  NcmDatasetdescricao.BeforeLoadDFMValues;
  NcmDatasetdata_inicio_vigencia.BeforeLoadDFMValues;
  NcmDatasetdata_fim_vigencia.BeforeLoadDFMValues;
  NcmDatasetexcluido.BeforeLoadDFMValues;
  NcmDatasetinclusao.BeforeLoadDFMValues;
  NcmDatasetalteracao.BeforeLoadDFMValues;
  NcmDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  XDataClientImportNcm.BeforeLoadDFMValues;
  XDataWebClientImportIbptax.BeforeLoadDFMValues;
  excelImport.BeforeLoadDFMValues;
  try
    Name := 'FViewNcmList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    lblErroNcm.SetParentComponent(Self);
    lblErroNcm.Name := 'lblErroNcm';
    lblErroNcm.Left := 123;
    lblErroNcm.Top := 468;
    lblErroNcm.Width := 24;
    lblErroNcm.Height := 13;
    lblErroNcm.Caption := 'Erro:';
    lblErroNcm.HeightPercent := 100.000000000000000000;
    lblErroNcm.Visible := False;
    lblErroNcm.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellData', 'WebDBTableControl1GetCellData');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellClass', 'WebDBTableControl1GetCellClass');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'A'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'C'#243'd.';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'ncm';
      Title := 'Ncm';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'descricao';
      Title := 'Descri'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_inicio_vigencia';
      Title := 'In'#237'cio Vig'#234'ncia';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_fim_vigencia';
      Title := 'Fim Vig'#234'ncia';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'Exclu'#237'do';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'Inclus'#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'Altera'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'Exclus'#227'o';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnKeyDown', 'edSearchKeyDown');
    SetEvent(edSearch, Self, 'OnKeyUp', 'edSearchKeyUp');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    cbbTipoImportacao.SetParentComponent(Self);
    cbbTipoImportacao.Name := 'cbbTipoImportacao';
    cbbTipoImportacao.Left := 8;
    cbbTipoImportacao.Top := 416;
    cbbTipoImportacao.Width := 145;
    cbbTipoImportacao.Height := 21;
    cbbTipoImportacao.HeightPercent := 100.000000000000000000;
    cbbTipoImportacao.WidthPercent := 100.000000000000000000;
    SetEvent(cbbTipoImportacao, Self, 'OnChange', 'cbbTipoImportacaoChange');
    SetEvent(cbbTipoImportacao, Self, 'OnClick', 'cbbTipoImportacaoClick');
    cbbTipoImportacao.ItemIndex := 0;
    cbbTipoImportacao.Items.BeginUpdate;
    try
      cbbTipoImportacao.Items.Clear;
      cbbTipoImportacao.Items.Add('');
      cbbTipoImportacao.Items.Add('1 - Ncm tabela SEFAZ');
      cbbTipoImportacao.Items.Add('2 - Ncm tabela IBPTAX (Individual - Atualiza'#231#227'o da descri'#231#227'o)');
      cbbTipoImportacao.Items.Add('3 - Tabelas IBPTAX (Todos os estados - Atualiza'#231#227'o das al'#237'quotas)');
    finally
      cbbTipoImportacao.Items.EndUpdate;
    end;
    btnImportarNcm.SetParentComponent(Self);
    btnImportarNcm.Name := 'btnImportarNcm';
    btnImportarNcm.Left := 8;
    btnImportarNcm.Top := 474;
    btnImportarNcm.Width := 96;
    btnImportarNcm.Height := 25;
    btnImportarNcm.Caption := 'Importar Ncm';
    btnImportarNcm.ChildOrder := 24;
    btnImportarNcm.HeightPercent := 100.000000000000000000;
    btnImportarNcm.TabStop := False;
    btnImportarNcm.WidthPercent := 100.000000000000000000;
    SetEvent(btnImportarNcm, Self, 'OnClick', 'btnImportarNcmClick');
    btnUploadNcm.SetParentComponent(Self);
    btnUploadNcm.Name := 'btnUploadNcm';
    btnUploadNcm.Left := 8;
    btnUploadNcm.Top := 443;
    btnUploadNcm.Width := 96;
    btnUploadNcm.Height := 25;
    btnUploadNcm.Caption := 'Importar';
    btnUploadNcm.ChildOrder := 24;
    btnUploadNcm.HeightPercent := 100.000000000000000000;
    btnUploadNcm.WidthPercent := 100.000000000000000000;
    SetEvent(btnUploadNcm, Self, 'OnClick', 'btnUploadNcmClick');
    wfpNcm.SetParentComponent(Self);
    wfpNcm.Name := 'wfpNcm';
    wfpNcm.Left := 123;
    wfpNcm.Top := 443;
    wfpNcm.Width := 134;
    wfpNcm.Height := 19;
    wfpNcm.Accept := '.pfx';
    wfpNcm.ChildOrder := 1;
    wfpNcm.Multifile := True;
    SetEvent(wfpNcm, Self, 'OnChange', 'wfpNcmChange');
    SetEvent(wfpNcm, Self, 'OnGetFileAsText', 'wfpNcmGetFileAsText');
    SetEvent(wfpNcm, Self, 'OnGetFileAsArrayBuffer', 'wfpNcmGetFileAsArrayBuffer');
    NcmDataset.SetParentComponent(Self);
    NcmDataset.Name := 'NcmDataset';
    NcmDataset.EntitySetName := 'Ncm';
    NcmDataset.Connection := DMConnection.ApiConnection;
    NcmDataset.Left := 72;
    NcmDataset.Top := 144;
    NcmDatasetid.SetParentComponent(NcmDataset);
    NcmDatasetid.Name := 'NcmDatasetid';
    NcmDatasetid.FieldName := 'id';
    NcmDatasetid.Required := True;
    NcmDatasetncm.SetParentComponent(NcmDataset);
    NcmDatasetncm.Name := 'NcmDatasetncm';
    NcmDatasetncm.FieldName := 'ncm';
    NcmDatasetncm.Required := True;
    NcmDatasetncm.Size := 255;
    NcmDatasetdescricao.SetParentComponent(NcmDataset);
    NcmDatasetdescricao.Name := 'NcmDatasetdescricao';
    NcmDatasetdescricao.FieldName := 'descricao';
    NcmDatasetdescricao.Size := 255;
    NcmDatasetdata_inicio_vigencia.SetParentComponent(NcmDataset);
    NcmDatasetdata_inicio_vigencia.Name := 'NcmDatasetdata_inicio_vigencia';
    NcmDatasetdata_inicio_vigencia.FieldName := 'data_inicio_vigencia';
    NcmDatasetdata_inicio_vigencia.DisplayFormat := 'dd/mm/yyyy';
    NcmDatasetdata_fim_vigencia.SetParentComponent(NcmDataset);
    NcmDatasetdata_fim_vigencia.Name := 'NcmDatasetdata_fim_vigencia';
    NcmDatasetdata_fim_vigencia.FieldName := 'data_fim_vigencia';
    NcmDatasetdata_fim_vigencia.DisplayFormat := 'dd/mm/yyyy';
    NcmDatasetexcluido.SetParentComponent(NcmDataset);
    NcmDatasetexcluido.Name := 'NcmDatasetexcluido';
    NcmDatasetexcluido.FieldName := 'excluido';
    NcmDatasetinclusao.SetParentComponent(NcmDataset);
    NcmDatasetinclusao.Name := 'NcmDatasetinclusao';
    NcmDatasetinclusao.FieldName := 'inclusao';
    NcmDatasetinclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    NcmDatasetalteracao.SetParentComponent(NcmDataset);
    NcmDatasetalteracao.Name := 'NcmDatasetalteracao';
    NcmDatasetalteracao.FieldName := 'alteracao';
    NcmDatasetalteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    NcmDatasetexclusao.SetParentComponent(NcmDataset);
    NcmDatasetexclusao.Name := 'NcmDatasetexclusao';
    NcmDatasetexclusao.FieldName := 'exclusao';
    NcmDatasetexclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := NcmDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    SetEvent(tmrConsulta, Self, 'OnTimer', 'tmrConsultaTimer');
    tmrConsulta.Left := 616;
    tmrConsulta.Top := 344;
    XDataClientImportNcm.SetParentComponent(Self);
    XDataClientImportNcm.Name := 'XDataClientImportNcm';
    XDataClientImportNcm.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientImportNcm, Self, 'OnLoad', 'XDataClientImportNcmLoad');
    SetEvent(XDataClientImportNcm, Self, 'OnError', 'XDataClientImportNcmError');
    XDataClientImportNcm.Left := 496;
    XDataClientImportNcm.Top := 440;
    XDataWebClientImportIbptax.SetParentComponent(Self);
    XDataWebClientImportIbptax.Name := 'XDataWebClientImportIbptax';
    XDataWebClientImportIbptax.Connection := DMConnection.ApiConnection;
    SetEvent(XDataWebClientImportIbptax, Self, 'OnLoad', 'XDataWebClientImportIbptaxLoad');
    SetEvent(XDataWebClientImportIbptax, Self, 'OnError', 'XDataWebClientImportIbptaxError');
    XDataWebClientImportIbptax.Left := 608;
    XDataWebClientImportIbptax.Top := 416;
    excelImport.SetParentComponent(Self);
    excelImport.Name := 'excelImport';
    SetEvent(excelImport, Self, 'OnSheetLoaded', 'excelImportSheetLoaded');
    excelImport.Left := 608;
    excelImport.Top := 192;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    lblErroNcm.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    cbbTipoImportacao.AfterLoadDFMValues;
    btnImportarNcm.AfterLoadDFMValues;
    btnUploadNcm.AfterLoadDFMValues;
    wfpNcm.AfterLoadDFMValues;
    NcmDataset.AfterLoadDFMValues;
    NcmDatasetid.AfterLoadDFMValues;
    NcmDatasetncm.AfterLoadDFMValues;
    NcmDatasetdescricao.AfterLoadDFMValues;
    NcmDatasetdata_inicio_vigencia.AfterLoadDFMValues;
    NcmDatasetdata_fim_vigencia.AfterLoadDFMValues;
    NcmDatasetexcluido.AfterLoadDFMValues;
    NcmDatasetinclusao.AfterLoadDFMValues;
    NcmDatasetalteracao.AfterLoadDFMValues;
    NcmDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
    XDataClientImportNcm.AfterLoadDFMValues;
    XDataWebClientImportIbptax.AfterLoadDFMValues;
    excelImport.AfterLoadDFMValues;
  end;
end;

end.
